import React from "react";

const FinAiChat = () => {
  return <div>FinAiChat</div>;
};

export default FinAiChat;
